import { useGame } from "../store";
import { fileUrl } from "../lib/paths";

/**
 * Full-image cue-card shown over the puzzle during audio narration, framed by
 * the show's fade PNG (matches the original .cue_card_area / .cue_fade).
 */
export function CueCard(): React.ReactElement | null {
  const cueImage = useGame((s) => s.cueImage);
  if (!cueImage) return null;
  return (
    <div className="cue_card_area" style={{ backgroundImage: `url(${fileUrl(cueImage)})` }}>
      <div className="cue_fade" />
    </div>
  );
}
